module.exports = __webpack_public_path__ + "static/media/warning-old.486f9fdd.png";